import { render, staticRenderFns } from "./UserEditTeams.vue?vue&type=template&id=44116baa"
import script from "./UserEditTeams.vue?vue&type=script&lang=js"
export * from "./UserEditTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports